export default __webpack_public_path__ + "97f016fe3523d67e3c2d147a1f913523.png";